{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Șabloane WhatsApp",
      "SUBTITLE": "Selectați șablonul WhatsApp pe care doriți să trimiteți",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Caută Șabloane",
      "NO_TEMPLATES_FOUND": "Nu s-au găsit șabloane pentru",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Categorie",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Limbă",
        "TEMPLATE_BODY": "Corpul șablonului",
        "CATEGORY": "Categorie"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Variabile",
      "LANGUAGE": "Limbă",
      "CATEGORY": "Categorie",
      "VARIABLE_PLACEHOLDER": "Introducerea {variable} valoare",
      "GO_BACK_LABEL": "Înapoi",
      "SEND_MESSAGE_LABEL": "Trimite mesaj",
      "FORM_ERROR_MESSAGE": "Vă rugăm să completați toate variabilele înainte de a trimite",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
